function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
var P8Header = function P8Header(_ref) {
  var page = _ref.page;
  var thisPage = 4;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    timeArr = _useState2[0],
    setTimeArr = _useState2[1];
  var clearTimers = function clearTimers() {
    timeArr.forEach(function (x) {
      return clearTimeout(x);
    });
    setTimeArr([]);
  };
  useEffect(function () {
    return function () {
      return clearTimers();
    };
  }, []);
  useEffect(function () {
    clearTimers();
    if (page === thisPage) {
      setTimeArr([setTimeout(function () {
        $('.p8-header').addClass('p8-header__active');
      }, 1500)]);
    } else {
      $('.p8-header').removeClass('p8-header__active');
    }
  }, [page]);
  return /*#__PURE__*/React.createElement("div", {
    className: "p8-header"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p8/soil-header-bg@3x.png",
    className: "p8-header__bg"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p8/soil-header-bg-stripe@3x.png",
    className: "p8-header__bar"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p8/water@3x.png",
    className: "p8-header__water"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p8/soil-washing-facts@3x.png",
    className: "p8-header__txt"
  }));
};
export default P8Header;